/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      name
      email
      contact
      phone
      address
      enabledMFA
      description
      accountType
      isLocked
      isActive
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      name
      email
      contact
      phone
      address
      enabledMFA
      description
      accountType
      isLocked
      isActive
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      name
      email
      contact
      phone
      address
      enabledMFA
      description
      accountType
      isLocked
      isActive
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSensor = /* GraphQL */ `
  mutation CreateSensor(
    $input: CreateSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    createSensor(input: $input, condition: $condition) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSensor = /* GraphQL */ `
  mutation UpdateSensor(
    $input: UpdateSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    updateSensor(input: $input, condition: $condition) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSensor = /* GraphQL */ `
  mutation DeleteSensor(
    $input: DeleteSensorInput!
    $condition: ModelSensorConditionInput
  ) {
    deleteSensor(input: $input, condition: $condition) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSensorGroup = /* GraphQL */ `
  mutation CreateSensorGroup(
    $input: CreateSensorGroupInput!
    $condition: ModelSensorGroupConditionInput
  ) {
    createSensorGroup(input: $input, condition: $condition) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSensorGroup = /* GraphQL */ `
  mutation UpdateSensorGroup(
    $input: UpdateSensorGroupInput!
    $condition: ModelSensorGroupConditionInput
  ) {
    updateSensorGroup(input: $input, condition: $condition) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSensorGroup = /* GraphQL */ `
  mutation DeleteSensorGroup(
    $input: DeleteSensorGroupInput!
    $condition: ModelSensorGroupConditionInput
  ) {
    deleteSensorGroup(input: $input, condition: $condition) {
      id
      name
      type
      messages {
        status
        message
        color
        value
        notification
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSensorHistory = /* GraphQL */ `
  mutation CreateSensorHistory(
    $input: CreateSensorHistoryInput!
    $condition: ModelSensorHistoryConditionInput
  ) {
    createSensorHistory(input: $input, condition: $condition) {
      sensorId
      status
      lat
      lng
      createdAt
      tx
      payload
      data
      updatedAt
      __typename
    }
  }
`;
export const createCameraSensorHistory = /* GraphQL */ `
  mutation CreateCameraSensorHistory(
    $input: CreateCameraSensorHistoryInput!
    $condition: ModelCameraSensorHistoryConditionInput
  ) {
    createCameraSensorHistory(input: $input, condition: $condition) {
      sensorId
      keyImage
      tx
      isAnalyzed
      status
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCameraSensorHistory = /* GraphQL */ `
  mutation DeleteCameraSensorHistory(
    $input: DeleteCameraSensorHistoryInput!
    $condition: ModelCameraSensorHistoryConditionInput
  ) {
    deleteCameraSensorHistory(input: $input, condition: $condition) {
      sensorId
      keyImage
      tx
      isAnalyzed
      status
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSensorChangeHistory = /* GraphQL */ `
  mutation CreateSensorChangeHistory(
    $input: CreateSensorChangeHistoryInput!
    $condition: ModelSensorChangeHistoryConditionInput
  ) {
    createSensorChangeHistory(input: $input, condition: $condition) {
      sensorId
      status
      lat
      lng
      createdAt
      tx
      payload
      data
      updatedAt
      __typename
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCameraTrafficVolumn = /* GraphQL */ `
  mutation CreateCameraTrafficVolumn(
    $input: CreateCameraTrafficVolumeInput!
    $condition: ModelCameraTrafficVolumeConditionInput
  ) {
    createCameraTrafficVolumn(input: $input, condition: $condition) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCameraTrafficVolumn = /* GraphQL */ `
  mutation DeleteCameraTrafficVolumn(
    $input: DeleteCameraTrafficVolumeInput!
    $condition: ModelCameraTrafficVolumeConditionInput
  ) {
    deleteCameraTrafficVolumn(input: $input, condition: $condition) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUserDeviceGroups = /* GraphQL */ `
  mutation CreateUserDeviceGroups(
    $input: CreateUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    createUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUserDeviceGroups = /* GraphQL */ `
  mutation UpdateUserDeviceGroups(
    $input: UpdateUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    updateUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUserDeviceGroups = /* GraphQL */ `
  mutation DeleteUserDeviceGroups(
    $input: DeleteUserDeviceGroupsInput!
    $condition: ModelUserDeviceGroupsConditionInput
  ) {
    deleteUserDeviceGroups(input: $input, condition: $condition) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTrafficMonitoring = /* GraphQL */ `
  mutation CreateTrafficMonitoring(
    $input: CreateTrafficMonitoringInput!
    $condition: ModelTrafficMonitoringConditionInput
  ) {
    createTrafficMonitoring(input: $input, condition: $condition) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTrafficMonitoring = /* GraphQL */ `
  mutation UpdateTrafficMonitoring(
    $input: UpdateTrafficMonitoringInput!
    $condition: ModelTrafficMonitoringConditionInput
  ) {
    updateTrafficMonitoring(input: $input, condition: $condition) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTrafficMonitoring = /* GraphQL */ `
  mutation DeleteTrafficMonitoring(
    $input: DeleteTrafficMonitoringInput!
    $condition: ModelTrafficMonitoringConditionInput
  ) {
    deleteTrafficMonitoring(input: $input, condition: $condition) {
      type
      routeId
      routeName
      routeDataKey
      trafficDirections
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLoginHistory = /* GraphQL */ `
  mutation CreateLoginHistory(
    $input: CreateLoginHistoryInput!
    $condition: ModelLoginHistoryConditionInput
  ) {
    createLoginHistory(input: $input, condition: $condition) {
      id
      userId
      loginTime
      success
      ipAddress
      userAgent
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLoginHistory = /* GraphQL */ `
  mutation DeleteLoginHistory(
    $input: DeleteLoginHistoryInput!
    $condition: ModelLoginHistoryConditionInput
  ) {
    deleteLoginHistory(input: $input, condition: $condition) {
      id
      userId
      loginTime
      success
      ipAddress
      userAgent
      ttl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAggregatedTrafficVolume = /* GraphQL */ `
  mutation CreateAggregatedTrafficVolume(
    $input: CreateAggregatedTrafficVolumeInput!
    $condition: ModelAggregatedTrafficVolumeConditionInput
  ) {
    createAggregatedTrafficVolume(input: $input, condition: $condition) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAggregatedTrafficVolume = /* GraphQL */ `
  mutation UpdateAggregatedTrafficVolume(
    $input: UpdateAggregatedTrafficVolumeInput!
    $condition: ModelAggregatedTrafficVolumeConditionInput
  ) {
    updateAggregatedTrafficVolume(input: $input, condition: $condition) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAggregatedTrafficVolume = /* GraphQL */ `
  mutation DeleteAggregatedTrafficVolume(
    $input: DeleteAggregatedTrafficVolumeInput!
    $condition: ModelAggregatedTrafficVolumeConditionInput
  ) {
    deleteAggregatedTrafficVolume(input: $input, condition: $condition) {
      cameraId
      bucketTime
      scenario_1_count
      scenario_2_count
      scenario_3_count
      scenario_4_count
      scenario_5_count
      scenario_6_count
      scenario_7_count
      scenario_8_count
      scenario_9_count
      scenario_10_count
      scenario_11_count
      scenario_12_count
      scenario_13_count
      scenario_14_count
      scenario_15_count
      scenario_16_count
      scenario_17_count
      scenario_18_count
      scenario_19_count
      scenario_20_count
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const adminCreateCognitoUser = /* GraphQL */ `
  mutation AdminCreateCognitoUser($input: AdminCreateCognitoUserInput) {
    adminCreateCognitoUser(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminSetCognitoUserPassword = /* GraphQL */ `
  mutation AdminSetCognitoUserPassword(
    $input: AdminSetCognitoUserPasswordInput
  ) {
    adminSetCognitoUserPassword(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminDeleteCognitoUser = /* GraphQL */ `
  mutation AdminDeleteCognitoUser($input: AdminDeleteCognitoUserInput) {
    adminDeleteCognitoUser(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminAddCognitoUserToAdminGroup = /* GraphQL */ `
  mutation AdminAddCognitoUserToAdminGroup(
    $input: AdminAddCognitoUserToAdminGroupInput
  ) {
    adminAddCognitoUserToAdminGroup(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminRemoveCognitoUserFromAdminGroup = /* GraphQL */ `
  mutation AdminRemoveCognitoUserFromAdminGroup(
    $input: AdminRemoveCognitoUserFromAdminGroupInput
  ) {
    adminRemoveCognitoUserFromAdminGroup(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminSetUserMFA = /* GraphQL */ `
  mutation AdminSetUserMFA($input: AdminSetUserMFAInput) {
    adminSetUserMFA(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const adminSendMail = /* GraphQL */ `
  mutation AdminSendMail($input: SendMailInput) {
    adminSendMail(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const handleImageAnalysis = /* GraphQL */ `
  mutation HandleImageAnalysis($input: HandleImageAnalysisInput!) {
    handleImageAnalysis(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const handleResetUserDeviceGroups = /* GraphQL */ `
  mutation HandleResetUserDeviceGroups(
    $input: HandleResetUserDeviceGroupsInput!
  ) {
    handleResetUserDeviceGroups(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
export const handleUserDisplayOrder = /* GraphQL */ `
  mutation HandleUserDisplayOrder($input: HandleUserDisplayOrderInput!) {
    handleUserDisplayOrder(input: $input) {
      success
      error
      data
      __typename
    }
  }
`;
